import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProdutoList.css';
import api from '../services/api';
import { toast } from 'react-toastify';

function EditarFornecedor() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [razao_social, setRazaoSocial] = useState('');
  const [nome_fantasia, setNomeFantasia] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [endereco, setEndereco] = useState('');
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFornecedor = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const res = await api.get(`/fornecedores/${id}/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRazaoSocial(res.data.razao_social || '');
        setNomeFantasia(res.data.nome_fantasia || '');
        setEmail(res.data.email || '');
        setTelefone(res.data.telefone || '');
        setCnpj(res.data.cnpj || '');
        setEndereco(res.data.endereco || '');
      } catch {
        toast.error('Erro ao carregar o fornecedor.');
      } finally {
        setLoading(false);
      }
    };
    fetchFornecedor();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const data = { razao_social, nome_fantasia, email, telefone, cnpj, endereco };
    const token = localStorage.getItem('access_token');
    const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
    try {
      await api.put(`/fornecedores/${id}/`, data, { headers });
      toast.success('Fornecedor atualizado com sucesso!');
      navigate('/fornecedores');
    } catch {
      toast.error('Erro ao atualizar o fornecedor.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="produto-page">

      <div className="produto-page-header">
        <div className="produto-page-title-row">
          <h2 className="produto-page-title">Fornecedores</h2>
          <div className="produto-tabs">
            <span className="produto-tab active">Editar Fornecedor</span>
            <span className="produto-tab" onClick={() => navigate('/fornecedores')}>
              Lista de Fornecedores
            </span>
          </div>
        </div>
      </div>

      <div className="prd-card prd-form-card">
        <div className="prd-card-accent" />
        <div className="prd-form-body">
          <header className="prd-form-header">
            <h3 className="prd-form-title">Informações do Fornecedor</h3>
            <p className="prd-form-sub">Atualize os dados do fornecedor.</p>
          </header>

          {loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="skeleton" style={{ height: '44px' }} />
              ))}
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="prd-form-left">
                <div className="prd-form-row3" style={{ gridTemplateColumns: '1fr 1fr' }}>
                  <div className="prd-field">
                    <label className="prd-label">Razão Social</label>
                    <input
                      className="prd-input"
                      type="text"
                      placeholder="Razão social da empresa"
                      value={razao_social}
                      onChange={(e) => setRazaoSocial(e.target.value)}
                      required
                    />
                  </div>
                  <div className="prd-field">
                    <label className="prd-label">Nome Fantasia</label>
                    <input
                      className="prd-input"
                      type="text"
                      placeholder="Nome fantasia (opcional)"
                      value={nome_fantasia}
                      onChange={(e) => setNomeFantasia(e.target.value)}
                    />
                  </div>
                </div>

                <div className="prd-form-row3" style={{ gridTemplateColumns: '1fr 1fr 180px' }}>
                  <div className="prd-field">
                    <label className="prd-label">Email</label>
                    <input
                      className="prd-input"
                      type="email"
                      placeholder="contato@fornecedor.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="prd-field">
                    <label className="prd-label">Telefone</label>
                    <input
                      className="prd-input"
                      type="text"
                      placeholder="(00) 00000-0000"
                      value={telefone}
                      onChange={(e) => setTelefone(e.target.value)}
                    />
                  </div>
                  <div className="prd-field">
                    <label className="prd-label">CNPJ</label>
                    <input
                      className="prd-input"
                      type="text"
                      placeholder="00.000.000/0000-00"
                      value={cnpj}
                      onChange={(e) => setCnpj(e.target.value)}
                    />
                  </div>
                </div>

                <div className="prd-field prd-field--full">
                  <label className="prd-label">Endereço</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="Rua, nº, bairro, cidade, estado"
                    value={endereco}
                    onChange={(e) => setEndereco(e.target.value)}
                  />
                </div>
              </div>

              <div className="prd-form-actions" style={{ gridColumn: 'unset', marginTop: '1.5rem' }}>
                <button
                  type="button"
                  className="prd-btn-cancel"
                  onClick={() => navigate('/fornecedores')}
                >
                  Cancelar
                </button>
                <button type="submit" className="prd-btn-save" disabled={saving}>
                  <span className="material-symbols-outlined">save</span>
                  {saving ? 'Salvando...' : 'Salvar Alterações'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default EditarFornecedor;
